module.exports = __webpack_public_path__ + "img/vipon-white.ef64253c.svg";